


































































































import { Component, Vue, Prop } from 'vue-property-decorator';
import { Order } from '@/models/order';
import { Product } from '@/models/product';
import { APP_CONFIG } from '@/config/app-config';
import commonService from '@/services/common-services';
import formatNumber from '@/shared/filters/format-number';

@Component
export default class AmountDetailOrder extends Vue {
    @Prop({default: { }})
    private receipt: any;    
}
